import { useState } from 'react'
import { LkmAppealDetailResult, TAppealModalInfo } from '../types'

export const useAppealButtonsUtils = () => {
  const [open, setOpen] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState<TAppealModalInfo | null>(
    null,
  )

  const handleCloseOfferModal = () => {
    setOpen(false)
    setSelectedOrder(null)
  }

  const handleOpenOfferModal = (id: number, name: string) => {
    setOpen(true)
    setSelectedOrder({
      number: id,
      name: name,
    })
  }

  const handleRespondButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    data: LkmAppealDetailResult,
  ) => {
    e.stopPropagation()
    e.preventDefault()
    handleOpenOfferModal(data.id, data.name)
  }

  return {
    open,
    selectedOrder,
    handleCloseOfferModal,
    handleOpenOfferModal,
    handleRespondButtonClick,
  }
}
